import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { GeolocalisationResponse } from '@icilalune/types';
import { Breakpoint } from '@icilalune/utils/responsive';
import { MenuItemContext } from '@nx-icilalune/data/icilalune/types';

export const ELEVATOR_GEO_LOC_PREF = new InjectionToken<
  Observable<GeolocalisationResponse | null>
>('ELEVATOR_GEO_LOC_PREF');

export const ELEVATOR_FEATURE_BREAKPOINT = new InjectionToken<
  Observable<Breakpoint>
>('ELEVATOR_FEATURE_BREAKPOINT');

export const ELEVATOR_CONTEXT = new InjectionToken<Observable<MenuItemContext>>(
  'ELEVATOR_CONTEXT'
);
